import React, { createContext, useState, useContext } from 'react';

// Создаем контекст
const TutorContext = createContext();

// Провайдер контекста
export const TutorProvider = ({ children }) => {
    const [selectedStudentForOrder, setSelectedStudentForOrder] = useState(null);

    const selectStudent = (student) => {
        setSelectedStudentForOrder(student);
    };

    const clearSelectedStudent = () => {
        setSelectedStudentForOrder(null);
    };

    return (
        <TutorContext.Provider value={{ selectedStudentForOrder, selectStudent, clearSelectedStudent }}>
            {children}
        </TutorContext.Provider>
    );
};

// Хук для удобного использования контекста
export const useTutor = () => {
    return useContext(TutorContext);
};